module.exports = __webpack_public_path__ + "media/images/flags/1x1/pan-31c24c07235e4d5327d0523c37fdcbe7.svg";